import React, { useState, useEffect } from "react";
import styles from "./ViewCartMobile.module.css";
import { NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import searchicon from "../../assets/icons/searchicon.png";

import axios from "axios";

import backbutton from "../../assets/icons/backbutton.png";
import FooterMobile from "../FooterMobile/FooterMobile";

const ViewCart = () => {
  const MAIN_URL = process.env.REACT_APP_URL

  const navigate = useNavigate();

  const handlePlaceOrder = () => {
    navigate("/checkout", { state: { cartItems, totalPrice } });
  };
  const [cartItems, setCartItems] = useState([]);
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);

  useEffect(() => {
    const fetchCartItems = async () => {
      try {
        const token = localStorage.getItem("token");
        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };
        const response = await axios.get(
          `${MAIN_URL}/api/cart/getCartItems`,
          config
        );
        console.log("Cart Items Response:", response.data);
        setCartItems(response.data.products);
      } catch (error) {
        console.error("Error fetching cart items:", error);
      }
    };

    fetchCartItems();
  }, []);

  // Calculate total price
  useEffect(() => {
    let totalQuantityCount = 0;
    let totalPriceCount = 0;
    cartItems.forEach((item) => {
      totalQuantityCount += parseInt(item.quantity);
      totalPriceCount += item.productId.price * parseInt(item.quantity);
    });
    setTotalQuantity(totalQuantityCount);
    setTotalPrice(totalPriceCount);
  }, [cartItems]);

  // Function to handle quantity change for a product
  const handleQuantityChange = (index, quantity) => {
    const updatedCartItems = [...cartItems];
    updatedCartItems[index].quantity = quantity;
    setCartItems(updatedCartItems);
  };

  return (
    <>
      <div className={styles.view_cart_page}>
        {/* Searchbar */}
        <div className={styles.header_bar}>
          <div className={styles.search_bar}>
            <img className={styles.search_img} src={searchicon} alt="" />
            <input
              type="text"
              className={styles.search_input}
              placeholder="Search Musicart"
              // onChange={handleSearch}
            />
          </div>
        </div>

        <div className={styles.viewcart_mainContainer}>
          {/* BACK BUTTON  */}
          <div className={styles.product_back_btn}>
            <NavLink to="/home">
              <button className={styles.back_btn}>
                <img src={backbutton} alt="backbutton" />
              </button>
            </NavLink>
          </div>

          <div className={styles.container}>
            {/* LEFT SIDE PRODUCT SECTION */}
            <div className={styles.product_section}>
              <div className={styles.product_conatiner}>
                {cartItems.map((item, index) => (
                  <div key={item.productId} className={styles.product_deatils}>
                    {/* left image  */}
                    <div className={styles.image_section}>
                      <img
                        src={item.productId.imgUrl}
                        alt={item.productId.productName}
                      />
                    </div>
                    {/* left image  */}
                    {/* deatils with price */}
                    <div className={styles.right_section}>
                      {/* deatils */}
                      <div className={styles.shortdetails}>
                        <span className={styles.sort_name}>
                          {item.productId.productName}
                        </span>
                        <span className={styles.price}>
                          {" "}
                          ₹{item.productId.price}
                        </span>
                        <span className={styles.product_color}>
                          Color: {item.productId.color}
                        </span>
                        <span className={styles.stock_status}>
                          {item.productId.stock}
                        </span>
                        <div className={styles.convenience_fee}>
                          <span className={styles.convenience_fee_text}>
                            Convenience Fee
                          </span>
                          <span className={styles.convenience_fee_count}>
                            ₹45
                          </span>
                        </div>
                        <div className={styles.quantity_section}>
                          <p className={styles.quantity}> Quantity</p>
                          <select
                            name="Quantity"
                            id="Quantity"
                            value={item.quantity}
                            onChange={(e) =>
                              handleQuantityChange(
                                index,
                                parseInt(e.target.value)
                              )
                            }
                          >
                            {Array.from({ length: 8 }, (_, index) => (
                              <option key={index + 1} value={index + 1}>
                                {index + 1}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      {/* price */}
                      <div className={styles.price_section}>
                        <p className={styles.price_total}>Total:</p>
                        <p className={styles.price_count}>
                          ₹{item.productId.price * item.quantity}{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* nichewala */}
            <div className={styles.bottom_section}>
              <div className={styles.total_amount}>
                <p className={styles.total_amount_text}>Total Amount</p>
                <p className={styles.total_amount_number}>₹{totalPrice + 45}</p>
              </div>
              <button
                className={styles.order_place_btn}
                onClick={handlePlaceOrder}
              >
                PLACE ORDER
              </button>
            </div>
          </div>
        </div>
        <FooterMobile />
      </div>
    </>
  );
};

export default ViewCart;
